import HubMemberSelectionDialog from "./HubMemberSelectionDialog";

export default function ManageManagerEnrolementDialog(props) {
    return <HubMemberSelectionDialog {...props} mode="managers" />;
}
